import { isDevelopment } from '@repo/utils';
import { Helmet } from 'react-helmet-async';

const GTM_SCRIPT = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0],
  j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-K5RPK75G');
`;

export default function Gtm() {
  const isDevMode = isDevelopment();
  if (isDevMode) {
    return null;
  } else {
    return (
      <Helmet defer={false}>
        <script type="text/javascript">{GTM_SCRIPT}</script>
      </Helmet>
    );
  }
}
